import {
  defaultLightTheme,
  defaultDarkTheme,
  radiantDarkTheme,
  radiantLightTheme,
  houseDarkTheme,
  houseLightTheme,
} from "react-admin";

const customRadiantLightTheme = {
  ...radiantLightTheme,
  components: {
    ...radiantLightTheme.components,
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: 'rgba(0, 0, 0, 0.6)', // Gray text color
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input': {
            color: 'rgba(0, 0, 0, 0.6)',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          color: 'rgba(0, 0, 0, 0.6)',
        },
      },
    },
  },
};

const customRadiantDarkTheme = {
  ...radiantDarkTheme,
  components: {
    ...radiantDarkTheme.components,
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: 'rgba(255, 255, 255, 0.7)', // Light gray for dark theme
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input': {
            color: 'rgba(255, 255, 255, 0.7)',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          color: 'rgba(255, 255, 255, 0.7)',
        },
      },
    },
  },
};

export const themes = [
    { name: "radiant", light: customRadiantLightTheme, dark: customRadiantDarkTheme },
    { name: "house", light: houseLightTheme, dark: houseDarkTheme },
    { name: "default", light: defaultLightTheme, dark: defaultDarkTheme },
];
